/*
 * des-daan-widget.js — De Egaline Schuur floating "Vraag Daan" widget toggle.
 *
 * Interaction island (02 §daan-widget / the prototype's `marcoOpen` state) for
 * snippets/des-daan-widget.liquid: the pill button toggles the popover, with
 * aria-expanded kept in sync, Escape-to-close (focus returns to the pill),
 * close button, and click-outside close. Without this script the popover
 * simply stays hidden — the page remains fully usable.
 *
 * Namespaced, no globals leaked. Safe to run more than once (editor reloads).
 */
(function () {
  "use strict";

  var ROOT_ATTR = "data-des-daan";
  var BOUND = "desDaanBound";

  function setOpen(root, open) {
    var popover = root.querySelector("[data-des-daan-popover]");
    var pill = root.querySelector("[data-des-daan-toggle]");
    if (!popover || !pill) {
      return;
    }
    popover.hidden = !open;
    pill.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      // Non-modal dialog: move focus to the close button so keyboard users
      // land inside the popover; Escape returns focus to the pill.
      var close = root.querySelector("[data-des-daan-close]");
      if (close) {
        close.focus();
      }
    }
  }

  function isOpen(root) {
    var popover = root.querySelector("[data-des-daan-popover]");
    return !!popover && !popover.hidden;
  }

  function bind(root) {
    if (root.dataset[BOUND]) {
      return;
    }
    root.dataset[BOUND] = "true";

    var pill = root.querySelector("[data-des-daan-toggle]");
    var close = root.querySelector("[data-des-daan-close]");
    if (!pill) {
      return;
    }

    pill.addEventListener("click", function () {
      setOpen(root, !isOpen(root));
    });

    if (close) {
      close.addEventListener("click", function () {
        setOpen(root, false);
        pill.focus();
      });
    }

    root.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen(root)) {
        event.stopPropagation();
        setOpen(root, false);
        pill.focus();
      }
    });

    // Click outside the widget closes the popover (but never steals focus).
    document.addEventListener("click", function (event) {
      if (isOpen(root) && !root.contains(event.target)) {
        setOpen(root, false);
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll("[" + ROOT_ATTR + "]");
    for (var i = 0; i < roots.length; i++) {
      bind(roots[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  // Theme editor re-renders sections without a full page load.
  document.addEventListener("shopify:section:load", init);
})();
